module.exports = __webpack_public_path__ + "img/total3.8ec2ff42.png";